/**
 * Limpeza de caracteres invisíveis em texto colado pelo usuário.
 *
 * Telefone copiado do app Contatos do macOS/iPhone (e do WhatsApp) vem
 * embrulhado em marcas de direção de texto: `U+202A` antes e `U+202C` depois.
 * Elas não aparecem na tela, `String.trim()` não as remove (trim só tira espaço
 * em branco — essas são caracteres de FORMATAÇÃO, categoria Unicode Cf) e
 * derrubam qualquer validação de lista branca. Foi o que reprovou o número
 * correto "554797791000" com "Formato de telefone inválido" em 26/08/2026.
 */

/**
 * Marcas invisíveis que grudam em texto copiado de outros aplicativos.
 *
 * A lista é EXPLÍCITA de propósito, em vez de `\p{Cf}`: ZWJ (`U+200D`) e ZWNJ
 * (`U+200C`) também são Cf, mas carregam significado — são o que mantém o emoji
 * composto (👨‍👩‍👧) inteiro e o que separa letras em persa/árabe/índico.
 * Varrer a categoria toda quebraria uma tag com emoji em vários emojis soltos.
 */
const INVISIBLE_CHARS =
  /[\u00AD\u061C\u180E\u200B\u200E\u200F\u202A-\u202E\u2060-\u2064\u2066-\u2069\uFEFF]/g;

/**
 * Remove as marcas invisíveis de um texto, preservando todo o resto.
 *
 * @param value - Texto cru vindo do input (normalmente colado)
 * @returns O mesmo texto sem as marcas invisíveis
 */
export const stripInvisibleChars = (value: string): string =>
  value.replace(INVISIBLE_CHARS, '');
